import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { FeatureFlagAPI } from './APITypes';

export class FeatureFlagRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  /**
   * Register user to a feature flag (opt-in)
   */
  public register = (flagKey: string): Promise<FeatureFlagAPI | undefined> => {
    const requestData = {
      endpoint: `/users/feature-flag/${flagKey}/register`,
      method: HttpMethod.PUT,
      body: JSON.stringify({ flag_key: flagKey }),
    };
    return this.requester.request(requestData).then((response: any) => response.data as FeatureFlagAPI);
  };

  /**
   * Unregister user from a feature flag (opt-out)
   */
  public unregister = (flagKey: string): Promise<FeatureFlagAPI | undefined> => {
    const requestData = {
      endpoint: `/users/feature-flag/${flagKey}/unregister`,
      method: HttpMethod.PUT,
      body: JSON.stringify({ flag_key: flagKey }),
    };
    return this.requester.request(requestData).then((response: any) => response.data as FeatureFlagAPI);
  };
}

export default FeatureFlagRequester;
